<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              Do you have an Employer Other Contribution?
            </div>
          </div>
          <div class="form-unit">
            <roe-employer-other-select
              :design="$v.formData"
            ></roe-employer-other-select>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showForm(formData)">
          <div
            v-show="
              +formData.plan_has_profit_sharing_contributions_picklist_id === 2
            "
            class="form-row form-row--center-full"
          >
            <div class="form-unit">
              <div class="common-label">
                Please answer the following questions regarding the Employer
                Matching Contribution for the PRIMARY group of employees covered
                by this plan
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Does the plan have an age requirement for Employer Other
                Contributions?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-age-requirement-select
                :design="$v.formData"
              ></roe-employer-other-age-requirement-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showAgeRequirement(formData)">
            <div class="form-unit">
              <div class="light-label">
                Age Requirement for
                <template v-if="+formData.age_requirement_profit_sharing === 3">
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-age-requirement-years-input
                :design="$v.formData"
              ></roe-employer-other-age-requirement-years-input>
              <div class="input-devider"></div>
              <roe-employer-other-age-requirement-months-input
                :design="$v.formData"
              ></roe-employer-other-age-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Does the plan have a service requirement for Employer Other
                Contributions?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-service-requirement-select
                :design="$v.formData"
              >
              </roe-employer-other-service-requirement-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showServiceRequirement(formData)">
            <div class="form-unit">
              <div class="light-label">
                Service Requirement for
                <template
                  v-if="+formData.service_requirement_profit_sharing === 3"
                >
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-service-requirement-months-input
                class="input-wrap--small"
                :design="$v.formData"
              ></roe-employer-other-service-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Is the Other Contribution fixed every year or can it vary from
                year to year?
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-type-select
                :design="$v.formData"
              ></roe-employer-other-type-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="common-label">
                Please indicate the formula used for the Employer Other
                Contribution
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-formula-select :design="$v.formData">
              </roe-employer-other-formula-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <template
            v-if="
              showCompensationPercentOrDollarLimit(formData) ||
                showFlatDollarAmount(formData) ||
                showIntegratedBase(formData)
            "
          >
            <div class="form-row-devider"></div>

            <div class="form-row">
              <div class="form-unit">
                <div class="main-label">
                  Please provide details of the Employer Other Contribution
                  formula chosen above:
                </div>
              </div>
              <div class="form-unit"></div>
              <div class="form-unit"></div>
            </div>

            <div
              class="form-row"
              v-if="showCompensationPercentOrDollarLimit(formData)"
            >
              <div class="form-unit">
                <div class="light-label">Percent of Compensation</div>
              </div>
              <div class="form-unit">
                <roe-employer-other-compensation-percent-input
                  :design="$v.formData"
                ></roe-employer-other-compensation-percent-input>
              </div>
              <div class="form-unit"></div>
            </div>

            <div class="form-row" v-if="showFlatDollarAmount(formData)">
              <div class="form-unit">
                <div class="light-label">Flat Dollar Amount</div>
              </div>
              <div class="form-unit">
                <roe-employer-other-flat-dollar-input :design="$v.formData">
                </roe-employer-other-flat-dollar-input>
              </div>
              <div class="form-unit"></div>
            </div>

            <template v-if="showIntegratedBase(formData)">
              <div class="form-row">
                <div class="form-unit">
                  <div class="light-label">Amount</div>
                </div>
                <div class="form-unit">
                  <roe-employer-other-integrated-wage-base-input
                    :design="$v.formData"
                  ></roe-employer-other-integrated-wage-base-input>
                </div>
                <div class="form-unit"></div>
              </div>

              <div class="form-row">
                <div class="form-unit">
                  <div class="light-label">Compensation below</div>
                </div>
                <div class="form-unit">
                  <roe-employer-other-integrated-percent-below-input
                    :design="$v.formData"
                  ></roe-employer-other-integrated-percent-below-input>
                </div>
                <div class="form-unit"></div>
              </div>

              <div class="form-row">
                <div class="form-unit">
                  <div class="light-label">Compensation above that amount</div>
                </div>
                <div class="form-unit">
                  <roe-employer-other-integrated-percent-above-input
                    :design="$v.formData"
                  ></roe-employer-other-integrated-percent-above-input>
                </div>
                <div class="form-unit"></div>
              </div>
            </template>
          </template>

          <template v-if="showCompensationPercentOrDollarLimit(formData)">
            <div class="form-row-devider"></div>

            <div class="form-row">
              <div class="form-unit">
                <div class="common-label">
                  Is there a dollar limit for Employer Other Contributions?
                </div>
              </div>
              <div class="form-unit">
                <roe-employer-other-dollar-maximum-radio :design="$v.formData">
                </roe-employer-other-dollar-maximum-radio>
              </div>
              <div class="form-unit"></div>
            </div>

            <div class="form-row" v-if="showDollarLimitAmount(formData)">
              <div class="form-unit">
                <div class="light-label">
                  Indicate the Maximum Employer Other Contribution an employee
                  can receive
                </div>
              </div>
              <div class="form-unit">
                <roe-employer-other-dollar-maximum-input :design="$v.formData">
                </roe-employer-other-dollar-maximum-input>
              </div>
              <div class="form-unit"></div>
            </div>
          </template>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Hire Date For Employer Other
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-hire-date-input :design="$v.formData">
              </roe-employer-other-hire-date-input>
            </div>
            <div class="form-unit"></div>
          </div>
          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Funding Frequency
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-funding-frequency-select
                :design="$v.formData"
              >
              </roe-employer-other-funding-frequency-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="main-label">
                Other questions about Employer Other Contributions
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                End-of-year (EOY) requirement applies
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-e-o-y-requirement-radio
                :design="$v.formData"
              ></roe-employer-other-e-o-y-requirement-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Plan Year Service Requirement applies
              </div>
            </div>
            <div class="form-unit">
              <roe-employer-other-service-req-applies-select
                :design="$v.formData"
              ></roe-employer-other-service-req-applies-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row" v-if="showHoursOrMonths(formData)">
            <div class="form-unit">
              <div class="light-label">Plan Year Service Requirement</div>
            </div>
            <div class="form-unit">
              <roe-employer-other-service-req-applies-input
                :design="$v.formData"
              ></roe-employer-other-service-req-applies-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="main-label">
                Please indicate if the definition of compensation INCLUDES the
                following for determining Employer Other Contributions:
              </div>
            </div>
            <div class="form-unit"></div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Overtime</div>
            </div>
            <div class="form-unit">
              <roe-employer-other-overtime-radio
                :design="$v.formData"
              ></roe-employer-other-overtime-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Bonuses</div>
            </div>
            <div class="form-unit">
              <roe-employer-other-bonuses-radio
                :design="$v.formData"
              ></roe-employer-other-bonuses-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Commissions</div>
            </div>
            <div class="form-unit">
              <roe-employer-other-comissions-radio
                :design="$v.formData"
              ></roe-employer-other-comissions-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Shift Differential</div>
            </div>
            <div class="form-unit">
              <roe-employer-other-shift-differential-radio
                :design="$v.formData"
              ></roe-employer-other-shift-differential-radio>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-small">
            <div class="form-unit">
              <div class="common-label">
                The Vesting Schedule for Employer Other Contribtion
              </div>
            </div>
            <div class="form-unit">
              <roe-vesting-select
                :design="$v.formData"
                type="other"
              ></roe-vesting-select>
            </div>
            <div class="form-unit"></div>
          </div>

          <roe-vesting-percent-inputs
            v-if="showVestingImmediateGraded(formData)"
            class="form-row--center-small"
            :design="$v.formData"
            input-class="input-wrap--smallest"
            type="other"
          ></roe-vesting-percent-inputs>

          <roe-vesting-percent-inputs
            v-if="showVestingImmediateCliff(formData)"
            :years-count="3"
            class="form-row--center-small"
            :design="$v.formData"
            input-class="input-wrap--smallest"
            type="other"
          ></roe-vesting-percent-inputs>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import {
  InvalidFormWatcherMixin,
  EmployerOtherMixin
} from "@/components/_shared/inputs/design/_mixins";
import {
  RoeEmployerOtherSelect,
  RoeEmployerOtherAgeRequirementSelect,
  RoeEmployerOtherAgeRequirementYearsInput,
  RoeEmployerOtherAgeRequirementMonthsInput,
  RoeEmployerOtherServiceRequirementSelect,
  RoeEmployerOtherServiceRequirementMonthsInput,
  RoeEmployerOtherFormulaSelect,
  RoeEmployerOtherFundingFrequencySelect,
  RoeEmployerOtherCompensationPercentInput,
  RoeEmployerOtherDollarMaximumRadio,
  RoeEmployerOtherDollarMaximumInput,
  RoeEmployerOtherFlatDollarInput,
  RoeEmployerOtherIntegratedWageBaseInput,
  RoeEmployerOtherIntegratedPercentBelowInput,
  RoeEmployerOtherIntegratedPercentAboveInput,
  RoeEmployerOtherTypeSelect,
  RoeEmployerOtherEOYRequirementRadio,
  RoeEmployerOtherServiceReqAppliesInput,
  RoeEmployerOtherServiceReqAppliesSelect,
  RoeEmployerOtherBonusesRadio,
  RoeEmployerOtherComissionsRadio,
  RoeEmployerOtherOvertimeRadio,
  RoeEmployerOtherShiftDifferentialRadio,
  RoeVestingSelect,
  RoeVestingPercentInputs,
  RoeEmployerOtherHireDateInput
} from "@/components/_shared/inputs/design/employer-other";
export default {
  name: "RoeEmployerContributionOtherForm",
  props: ["formData"],
  mixins: [InvalidFormWatcherMixin, EmployerOtherMixin],
  components: {
    RoeEmployerOtherHireDateInput,
    RoeVestingPercentInputs,
    RoeVestingSelect,
    RoeEmployerOtherDollarMaximumInput,
    RoeEmployerOtherDollarMaximumRadio,
    RoeEmployerOtherFundingFrequencySelect,
    RoeEmployerOtherIntegratedPercentAboveInput,
    RoeEmployerOtherIntegratedPercentBelowInput,
    RoeEmployerOtherIntegratedWageBaseInput,
    RoeEmployerOtherFlatDollarInput,
    RoeEmployerOtherCompensationPercentInput,
    RoeEmployerOtherFormulaSelect,
    RoeEmployerOtherTypeSelect,
    RoeEmployerOtherServiceRequirementMonthsInput,
    RoeEmployerOtherServiceRequirementSelect,
    RoeEmployerOtherAgeRequirementMonthsInput,
    RoeEmployerOtherAgeRequirementYearsInput,
    RoeEmployerOtherAgeRequirementSelect,
    RoeEmployerOtherSelect,
    RoeEmployerOtherEOYRequirementRadio,
    RoeEmployerOtherServiceReqAppliesInput,
    RoeEmployerOtherServiceReqAppliesSelect,
    RoeEmployerOtherBonusesRadio,
    RoeEmployerOtherComissionsRadio,
    RoeEmployerOtherOvertimeRadio,
    RoeEmployerOtherShiftDifferentialRadio
  },
  validations() {
    return {
      formData: this.employerOtherValidations(this.formData)
    };
  }
};
</script>
